import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactStatsCards = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Contacts',
      value: stats?.totalContacts,
      change: '+12%',
      changeType: 'positive',
      icon: 'Users',
      color: 'text-primary'
    },
    {
      title: 'Active Relationships',
      value: stats?.activeContacts,
      change: '+8%',
      changeType: 'positive',
      icon: 'UserCheck',
      color: 'text-success'
    },
    {
      title: 'High Engagement',
      value: stats?.highEngagement,
      change: '+15%',
      changeType: 'positive',
      icon: 'TrendingUp',
      color: 'text-warning'
    },
    {
      title: 'Response Rate',
      value: `${stats?.responseRate}%`,
      change: '+3%',
      changeType: 'positive',
      icon: 'MessageCircle',
      color: 'text-accent'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statCards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-1">
                {card?.title}
              </p>
              <p className="text-2xl font-bold text-foreground">
                {card?.value}
              </p>
              <div className="flex items-center mt-2">
                <Icon 
                  name={card?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                  className={card?.changeType === 'positive' ? 'text-success' : 'text-error'} 
                />
                <span className={`text-sm font-medium ml-1 ${
                  card?.changeType === 'positive' ? 'text-success' : 'text-error'
                }`}>
                  {card?.change}
                </span>
                <span className="text-sm text-muted-foreground ml-1">
                  vs last month
                </span>
              </div>
            </div>
            <div className={`p-3 rounded-full bg-muted/30`}>
              <Icon name={card?.icon} size={24} className={card?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactStatsCards;